module.exports = __webpack_public_path__ + "static/media/1015332.f8ef971a.png";